require('./MarketsViewCalendar.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const moment = require('moment');

// @components
const BrokerMarketsCalendarDatePicker = require('components/broker/brokerMarketsCalendarDatePicker/brokerMarketsCalendarDatePicker');
const BrokerMarketsCalendarEvents = require('components/broker/brokerMarketsCalendarEvents/brokerMarketsCalendarEvents');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKLink } = require('commonsComponents/OKLink');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @constants
const { DATE_FORMAT_API, BROKER_MARKET_CALENDAR_MAX_EVENTS } = require('constants/index');

class MarketsViewCalendar extends React.Component {
    buildDateText(dateSelected, todayText) {
        const today = moment().format(DATE_FORMAT_API);

        if (today === dateSelected) {
            todayText[0] = todayText[0].toLowerCase();

            return (
                <FormattedText value="broker-marketsCalendarTodayText" injectedStrings={todayText} />
            )
        } else {
            return (
                <FormattedText value="broker-marketsCalendarDateText" injectedStrings={todayText} />
            )
        }
    }

    buildEventsBlock(events, MAX_EVENTS) {
        if (events.size > 0) {
            return (
                <BrokerMarketsCalendarEvents
                    events={events}
                    max={MAX_EVENTS}
                    pageName={this.props.pageName}
                />
            );
        } else {
            return (
                <div className="broker-markets-calendar__empty-state">
                    <EmptyState
                        primaryText={formatText('broker-marketsCalendarEmptyStateText')}
                        iconType="agenda-wealth"
                        pageName={this.props.pageName}
                    />
                </div>
            );
        }
    }

    render() {
        const {
            marketAgendaText,
            periodText,
            daysOfWeek,
            dateSelected,
            todayText,
            quantity,
            eventsText,
            calendarEvents,
            seeAllEventsText,
            handleCalendarStateChange,
        } = this.props;

        const MAX_EVENTS_MARKETS = BROKER_MARKET_CALENDAR_MAX_EVENTS;
        const dateTextBlock = this.buildDateText(dateSelected, todayText);
        const eventsBlock = this.buildEventsBlock(calendarEvents, MAX_EVENTS_MARKETS);

        const seeAllLink = (
            <div className="broker-markets-calendar__show-all">
                <OKLink
                    to="/myprofile/broker/marketsAgenda"
                    modifier="widget"
                >
                    {seeAllEventsText}
                </OKLink>
            </div>
        );

        const totalCount = (
            <div className="broker-markets-calendar__count">
                {quantity} {eventsText}
            </div>
        )

        return (
            <ContentBox
                id="broker-markets-calendar"
                title={marketAgendaText}
                smallTitle={true}
                customClassName="broker-markets-calendar"
                rightContent={totalCount}
                modifier="complementary"
                product="wealth"
                footerContent={seeAllLink}
            >
                <div className="broker-markets-calendar__period">
                    <FormattedText
                        className="broker-markets-calendar__period-text"
                        value="broker-marketsCalendarPeriodText"
                        injectedStrings={periodText}
                    />
                    <div className="broker-markets-calendar__period-icon">
                        <OKIconIllustrative icon="agenda" product="wealth" />
                    </div>
                </div>
                <div className="broker-markets-calendar__date-picker">
                    <BrokerMarketsCalendarDatePicker
                        daysOfWeek={daysOfWeek}
                        dateSelected={dateSelected}
                        onStateChange={handleCalendarStateChange}
                    />
                </div>
                <div className="broker-markets-calendar__today">
                    <h3 className="broker-markets-calendar__today-title">
                        {dateTextBlock}
                    </h3>
                </div>
                {eventsBlock}
            </ContentBox>
        );
    }
}

MarketsViewCalendar.propTypes = {
    handleCalendarStateChange: PropTypes.func,
    marketAgendaText: PropTypes.string,
    eventsText: PropTypes.string,
    seeAllEventsText: PropTypes.string,
    dateSelected: PropTypes.string,
    periodText: PropTypes.array,
    todayText: PropTypes.array,
    daysOfWeek: PropTypes.array,
    calendarEvents: PropTypes.array,
    quantity: PropTypes.number,
    pageName: PropTypes.string
}

module.exports = MarketsViewCalendar;
